import React from "react";
import { useLang } from "../../i18n/Metronici18n";

function SplashScreen() {
  const lang = useLang();
  return (
    <div className="splash-screen">
      <span>{lang === "de" ? "Laden..." : "Loading..."}</span>
    </div>
  );
}

export default SplashScreen;